import type { OrderCancelParams } from '../hooks/useFixTradingWebSocket'
import type { PendingOrderWithLots } from '../hooks/usePendingOrdersWithLots'
import { sideMapping } from './mapping'

export function getCancelOrderParams(order: PendingOrderWithLots): OrderCancelParams | undefined {
  if (!order.account || !order.instrument || !order.clientOrderId || !order.side) return undefined
  const sideFix = sideMapping(order.side)
  if (!sideFix) return undefined

  const account = order.account
  const symbol = order.instrument
  const origClOrdID = order.clientOrderId
  const listId = account
  return {
    origClOrdID,
    account,
    listId,
    symbol,
    side: sideFix,
  }
}
